// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".OtherButton-module__wrapper___Ima\\+d {\n  text-align: center;\n  background-color: #FFFFFF;\n  width: 315px;\n  height: 70px;\n  border-radius: 5px;\n  border:1px solid #ff9100;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.OtherButton-module__text___AtOgj {\n  font-size: 16px;\n  font-family: \"Hiragino Sans\", \"Hiragino Kaku Gothic ProN\", Meiryo, \"sans-serif\";\n  font-weight: 500;\n  color: #ff9100;\n}\n\n.OtherButton-module__selected___vCARL{\n  background-color: #FFE7B7;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "OtherButton-module__wrapper___Ima+d",
	"text": "OtherButton-module__text___AtOgj",
	"selected": "OtherButton-module__selected___vCARL"
};
export default ___CSS_LOADER_EXPORT___;
